import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);


export default new Vuex.Store({
    modules: {

    },
    state: {
        isChinese: true
    },
    getters: {
    },
    mutations: {
        updateLanguage(state, isChinese) {
            state.isChinese = isChinese;
        },

    },
})